// extracted by mini-css-extract-plugin
export var container = "styles-module__container___WctqR";
export var withElevationPane = "styles-module__withElevationPane___bOpnu";